import Helper from "./Helper";

class CV {
  constructor() {
    this.cvToggleSelector = ".ns-cv__collapse .ns-cv__collapse-icon";
    this.cvs = Array.prototype.slice.call(
      document.querySelectorAll(this.cvToggleSelector)
    );

    if (this.cvs && this.cvs.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.cvs.forEach((el) => {
      el.addEventListener("click", (e) => {
        const coll = el.parentElement;
        const content = coll.previousElementSibling;
        if (coll.classList.contains("active")) {
          Helper.slideClose(content);
          coll.classList.remove("active");
          content.classList.remove("active");
        } else {
          coll.classList.add("active");
          Helper.slideOpen(content, true);
          content.classList.add("active");
        }
      });
    });
  }
}

export default CV;
